<template>
    <form :action="action" class="registration-form" method="POST" v-on:submit="onSubmit($event)" ref="form">
        <md-card>
            <md-card-header>
                <div class="md-title md-title-dark" v-html="$t('registration.password-creation-' + registrationType, {'days': discoveryDays})"></div>
            </md-card-header>

            <md-card-content>
                <div class="form-row">
                    <md-field v-bind:class="{'md-invalid': !!errors['password']}">
                        <label>{{ $t('registration.password') }}</label>
                        <md-input type="password" name="password" v-model="fData.password" :disabled="submitting ? 'disabled' : null" @focus="passwordFieldFocused = true; passwordFieldTouched = true" @blur="passwordFieldFocused = false;" required></md-input>
                        <span class="md-helper-text" v-show="passwordFieldFocused">{{ $t('validation.passwordrules') }}</span>
                        <span class="md-error">{{ errors['password'] ? errors['password'][0] : '' }}</span>
                    </md-field>
                    <md-field v-bind:class="{'md-invalid': !!errors['password_confirmation']}">
                        <label>{{ $t('registration.password-confirmation') }}</label>
                        <md-input type="password" name="password_confirmation" v-model="fData.password_confirmation" :disabled="submitting ? 'disabled' : null" required></md-input>
                        <span class="md-error">{{ errors['password_confirmation'] ? errors['password_confirmation'][0] : '' }}</span>
                    </md-field>
                </div>
            </md-card-content>
        </md-card>
        <submit-button type="submit" class="registration-standalone-button" :submitting="submitting" :label="$t('registration.create-password')" v-on:click="onSubmit()" dusk="create-password-button"></submit-button>
    </form>
</template>

<script>
export default {
    props: {
        action: {
            required: true,
            type: String,
        },
        formData: {
            type: String,
            default: '{}',
        },
        registrationType: {
            type: String,
            default: '',
        },
        discoveryDays: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            fData: {
                password: '',
                password_confirmation: '',
            },
            errors: {
                password: null,
                password_confirmation: null,
            },
            csrkToken: Laravel.csrfToken,
            submitting: false,
            passwordFieldTouched: false,
            passwordFieldFocused: false,
            passwordRules: [
                {
                    key: 'length',
                    label: 'registration.min-characters',
                    labelParams: {minchars: 8},
                    passes: false,
                },
                {
                    key: 'lowercase',
                    label: 'registration.needs-lowercase',
                    labelParams: {minchars: 8},
                    passes: false,
                },
                {
                    key: 'uppercase',
                    label: 'registration.needs-uppercase',
                    labelParams: {minchars: 8},
                    passes: false,
                },
                {
                    key: 'digit',
                    label: 'registration.needs-digit',
                    labelParams: {minchars: 8},
                    passes: false,
                },
            ],
        };
    },
    methods: {
        onSubmit(event) {
            this.submitting = true;
            for (var i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }
            if (event) {
                event.preventDefault();
            }
            axios.post(this.$refs.form.action, this.fData).then((response) => {
                if (response.data['status'] == 'ok') {
                    window.location = response.data['redirect'];
                } else {
                    this.submitting = false;
                }
            }).catch((error) => {
                this.submitting = false;
                for (var i of Object.keys(this.errors)) {
                    this.errors[i] = error.response.data.errors[i];
                }
            });
        }
    },
    mounted() {
        let formDataObj = JSON.parse(this.formData);
        for (var i of Object.keys(formDataObj)) {
            this.fData[i] = formDataObj[i];
        }
        this.fData['password_confirmation'] = this.fData['password'];
    },
    watch: {
        'fData.password': function(value) {
            this.errors['password'] = null;
        },
        'fData.password': function(value) {
            this.errors['password_confirmation'] = null;
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/PasswordFormComponent.vue